import React from 'react'
import { Box, Paper, Stack, Table, TableBody, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { ObservatoryValue, ObservatoryRow } from 'common/types'
import { StageForecastHours } from 'common/consts'
import { StyledTableCell } from 'components/ui/StyledTableCell'
import { StyledTableRow } from 'components/ui/StyledTableRow'
import { PumpChart } from './PumpChart'
import dayjs from 'dayjs'

export const PumpDetail = () => {
  const state = useGlobalState()
  const [observatory, setObservatory] = React.useState<ObservatoryRow | null>(null)
  const [timeSeries, setTimeSeries] = React.useState<ObservatoryValue[]>([])

  React.useEffect(() => {
    setObservatory(state.observatory.selected)
  }, [state.observatory.selected])

  const filterTimeSeries = () => {
    let base_date = dayjs.utc(state.app.baseDate).clone()
    const latest = state.observatory.timeSeries.filter(ts => ts.type === 'real').pop()
    if (latest !== undefined) {
      base_date = dayjs.utc(latest.date, 'YYYY/MM/DD HH:mm')
    }

    const limitDate = base_date.add(StageForecastHours, 'hours').format('YYYY/MM/DD HH:mm')
    setTimeSeries(state.observatory.timeSeries
      .filter(ts => ts.date <= limitDate)
      .map(ts => {
        const jst = dayjs.utc(ts.date).local().format('YYYY/MM/DD HH:mm')
        return {
          date: jst,
          type: ts.type,
          level: ts.type === 'real' ? ts.level_river : ts.level,
        }
      }))
  }

  React.useEffect(() => {
    filterTimeSeries()
  }, [state.observatory.timeSeries])

  const getTimeSeriesColor = (row: ObservatoryValue) => {
    return row.type === 'forecast' ? blue[500] : grey[900]
  }

  return ( observatory &&
    <Box>

      <Stack direction="row" width={230}>
        <Typography variant='caption' color={grey[700]} flexGrow={1}>予測期間</Typography>
      </Stack>

      { timeSeries.length > 0 && (
        <Stack direction="column">
          <Typography variant='caption'>（m）</Typography>
          <PumpChart observatory={observatory} height={220} timeSeries={timeSeries} />
        </Stack>
      )}

      <TableContainer component={Paper}>
        <Table size="small" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell width={180}>日時</StyledTableCell>
              <StyledTableCell width={130}>水位（m）</StyledTableCell>
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {timeSeries.map((ts, i) => (
              <StyledTableRow key={i}>
                <StyledTableCell component="th" scope="row" color={getTimeSeriesColor(ts)}>
                  <Typography variant='body2'>{ts.date}</Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography variant='body2' textAlign={'right'} color={getTimeSeriesColor(ts)}>
                    {ts.level === undefined ? '-' : ts.level.toFixed(2)}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          {
            timeSeries.length === 0 && (
              <TableFooter>
                <TableRow>
                  <StyledTableCell colSpan={3}>データがありません</StyledTableCell>
                </TableRow>
              </TableFooter>
            )
          }
        </Table>
      </TableContainer>

    </Box>
  )
}
